module.exports = __webpack_public_path__ + "static/img/car_9_6_box@3x.105bb6a1.png";